import { Typography } from '@mui/material'
import { setPatientInfo } from '../ProrithmSlice'
import { useAppDispatch } from '../../../app/hooks'
import { IpdSearchOptions, constants } from '../Constants'
import { searchPatient } from '../../../services/ProrithmServices'
import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { MapToPatientOptions } from '../MappingForms/MapToPatientOptions'
import { MapUnidentifiedPatientForm } from '../MappingForms/MapUnidentifiedPatientForm'
import MapNewPatientform from '../MappingForms/MapNewPatientForm'
import SearchByPatient from '../SearchByPatient'

export const PatientMappingForm = ({
  mapTo,
  mapToPatient,
  handleMapToPatientChange,
}: {
  mapTo: string
  mapToPatient: string
  handleMapToPatientChange: (event: ChangeEvent<HTMLInputElement>) => void
}) => {
  const dispatch = useAppDispatch()
  const [searchQue, setSearchQue] = useState<{
    key: string
    value: string
  } | null>(null)
  const [ipdSearchData, setIpdSearchData] = useState<IpdSearchOptions[] | null>(
    null
  )

  const fetchPatientsList = useCallback(async () => {
    const type = searchQue?.key ?? ''
    const value = searchQue?.value ?? ''
    const data = await searchPatient(type, value, false)
    if (data?.success) {
      setIpdSearchData(data?.data ?? [])
      dispatch(setPatientInfo(null))
    } else {
      setIpdSearchData([])
    }
  }, [dispatch, searchQue?.key, searchQue?.value])

  const handleSearch = (query: string, param: string) => {
    const trimmedQuery = query?.trim()
    if (!trimmedQuery) {
      setSearchQue(null)
      return
    }
    setSearchQue({ key: param, value: trimmedQuery })
  }

  const resetSearch = useCallback(() => {
    setSearchQue(null)
    setIpdSearchData(null)
    dispatch(setPatientInfo(null))
  }, [dispatch])

  useEffect(() => {
    if (searchQue) fetchPatientsList()
  }, [fetchPatientsList, searchQue])

  useEffect(() => {
    resetSearch()
  }, [mapTo, dispatch, mapToPatient, resetSearch])

  const MapExistingPatientForm = () => {
    return (
      <SearchByPatient
        mapTo={mapTo}
        handleSearch={handleSearch}
        data={ipdSearchData}
      />
    )
  }

  const renderFormByType = () => {
    switch (mapToPatient) {
      case constants?.existing:
        return <MapExistingPatientForm />
      case constants?.new:
        return <MapNewPatientform />
      case constants?.unidentified:
        return <MapUnidentifiedPatientForm />
      default:
        return null
    }
  }

  return (
    <>
      <Typography>{constants?.mapPatient}:</Typography>
      {mapTo === constants?.ipd ? (
        <MapExistingPatientForm />
      ) : (
        <>
          <MapToPatientOptions
            mapTo={mapTo}
            mapToPatient={mapToPatient}
            handleMapToPatientChange={handleMapToPatientChange}
          />
          {renderFormByType()}
        </>
      )}
    </>
  )
}
